import { variant } from 'styled-system';

import { withComponentTheme } from './withComponentTheme';

interface ComponentVariantConfig {
  prop: string;
  variants: Record<string, Record<string, unknown>>;
}

export const componentVariant = (config: ComponentVariantConfig) => {
  const variantFn = variant(config);
  return <T extends { theme?: unknown }>(props: T) =>
    variantFn(withComponentTheme(props));
};
